import { useNavigate, useParams } from "react-router-dom";
import { Header } from "./components/Header";
import { Col, Row } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ListView } from "./components/ListView";
import { PaymentDetails } from "./components/DetailsView/PaymentDetails";
import { useFetchData } from "./hooks/useFetchData";
import { useFetchYears } from "./hooks/useFetchYears";
import { Loader } from "../../../components/Loader";
import { Error } from "../../../components/Error";
import { useFetchExternalPortalAccountData } from "../../../lib/hooks/useFetchExternalPortalAccountData";
import "./styles.scss";

export const UserPaymentHistory = () => {
  const { accountId } = useParams();

  const accountNumber: number = useMemo(() => {
    return accountId ? +accountId : NaN;
  }, [accountId]);

  const [page, setPage] = useState<string>("");

  const [paymentRecord, setPaymentRecord] = useState<any>(null);

  const [error, setError] = useState<string | null>(null);

  const [year, setYear] = useState<number | undefined>(undefined);

  const navigate = useNavigate();

  const onBackButtonClicked = useCallback(() => navigate(-1), [navigate]);

  const exitPage = useCallback(() => navigate(-1), [navigate]);

  const { data, roleInfo, isLoading } = useFetchExternalPortalAccountData(
    accountNumber,
    setError,
  );

  const { data: years, isLoading: isLoadingYears } =
    useFetchYears(accountNumber);

  const { data: paymentHistory, isLoading: isLoadingPaymentHistory } =
    useFetchData(accountNumber, year || 0);

  useEffect(() => {
    setPage("list");
    setYear(undefined);
  }, [accountId]);

  return (
    <Row className="d-block page-content ph-page">
      {error ? (
        <Error
          accountNumber={accountNumber}
          error={error}
          onBackButtonClicked={onBackButtonClicked}
          showHeader
        />
      ) : (
        <>
          {isLoading ? (
            <Row className="w-100 justify-center h-100">
              <Loader fontSize="64px" />
            </Row>
          ) : (
            <>
              {data && (
                <Header
                  title={
                    page === "list"
                      ? "Payment History"
                      : page === "details"
                        ? "Payment Details"
                        : ""
                  }
                  accountId={data.generalInformation.accountNumber}
                  onBackButtonClicked={
                    page === "list"
                      ? exitPage
                      : page === "details"
                        ? () => setPage("list")
                        : undefined
                  }
                />
              )}
              <Row className="cards-row">
                <Col className="cards-container">
                  {page === "list" && (
                    <ListView
                      contractGeneralData={data.generalInformation}
                      years={years}
                      year={year}
                      setYear={setYear}
                      paymentHistory={paymentHistory}
                      isLoadingYears={isLoadingYears}
                      isLoadingPaymentHistory={isLoadingPaymentHistory}
                      setPage={setPage}
                      setPaymentRecord={setPaymentRecord}
                    />
                  )}
                  {page === "details" && (
                    <PaymentDetails
                      paymentRecord={paymentRecord}
                      accountRoleInfo={roleInfo}
                    />
                  )}
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </Row>
  );
};
